module.exports = __webpack_public_path__ + "img/Resume-pic5@2x.8b7d060a.webp";